import { PagedListRequestInterface, PagedResponseInterface, PaginatedAPIInterface } from '@vendasta/galaxy/table';
import { BehaviorSubject, Observable, distinctUntilChanged } from 'rxjs';
import { CrmBoardDatasourceInterface } from './interfaces';

export class CrmBoardDatasource<RowType, FilterType, SortType = void>
  implements CrmBoardDatasourceInterface<RowType, FilterType, SortType>
{
  private readonly searchTerm$$ = new BehaviorSubject<string>('');
  readonly searchTerm$ = this.searchTerm$$.asObservable().pipe(distinctUntilChanged());
  private readonly filters$$ = new BehaviorSubject<FilterType[]>([]);
  readonly filters$ = this.filters$$.asObservable().pipe(distinctUntilChanged());
  private readonly sorting$$ = new BehaviorSubject<SortType[]>([]);
  readonly sorting$ = this.sorting$$.asObservable().pipe(distinctUntilChanged());

  constructor(private api: PaginatedAPIInterface<RowType, FilterType, SortType>) {
    this.api = api;
  }

  setSearchTerm(searchTerm?: string): void {
    this.searchTerm$$.next(searchTerm ?? '');
  }

  setFilters(filters?: FilterType[]): void {
    this.filters$$.next(filters ?? []);
  }

  setSorting(sorting?: SortType[]): void {
    this.sorting$$.next(sorting ?? []);
  }

  get(request: PagedListRequestInterface<FilterType, SortType>): Observable<PagedResponseInterface<RowType>> {
    return this.api.get(request);
  }
}
